/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptions } from './FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptions';
import {
    instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptions,
    FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptionsFromJSON,
    FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptionsFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptionsToJSON,
} from './FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptions';

/**
 * @type FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptions
 * 
 * @export
 */
export type FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptions = FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptions;

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptionsFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptions {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptionsFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptions {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptions(json)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptionsToJSON(json: any): any {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptionsToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptionsToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateFromSocialRequestWeChatMiniGameOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptions(value)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptionsToJSON(value as FxIdApplicationHandlersAuthAuthenticateFromSocialWeChatMiniGameOptions);
    }

    return {};
}

